import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FileUpload } from 'primeng/fileupload';
import { environment } from '../../../../environments/environment';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { UploadService } from '../../../services/upload/upload.service';
import { DmsFile } from '../../../modal/upload/model/upload.model';
@Component({
  selector: 'app-initiation-of-proposal',
  standalone: false,
  templateUrl: './initiation-of-proposal.component.html',
  styleUrl: './initiation-of-proposal.component.scss'
})
export class InitiationOfProposalComponent implements OnInit {

  @Input() id: any
  @Input() getUrl: any
  @Input() postUrl: any
  proposalForm: FormGroup;
  baseUrl: string = environment.APIUrl;
  payload: any;
  @Input() step: any;
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Input() stepDetails: any;
  @Input() schemeType: any;
  needGenData: any;
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  constructor(private api: ApiService, private uploadService:UploadService, private route: ActivatedRoute) { }
  expandedSections={
    expandedSections:false
  }
  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        proposal_name: proposalName
      }
    });
    this.getProposalData();
  }

 
  getProposalData() {
    let baseUrl = '';

  if (this.schemeType === 'tdf') {
    baseUrl = '/tdf/need-generation/';
  } else if (['makeI', 'makeII', 'makeIII'].includes(this.schemeType)) {
    baseUrl = '/make1/need-generation/';
  } else {
    baseUrl = '/revenue/initiation/project/';
  }

  const url = `${baseUrl}?proposal_step=${this.id}&proposal_step__proposal=${this.payload.proposal_id}`;
     this.api.getAPI(url).subscribe((res: any) => {
      this.needGenData = res;
      });
  }





}
